import TextInput from "@/components/shared/forms/TextInput";
import { formatDateOnly } from "@/utils/dates";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  type UseControllerProps,
  useController,
} from "react-hook-form";

type ReadOnlyDateInputProps<TFieldValues extends FieldValues> = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "name" | "value" | "readOnly"
> & {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  rules?: UseControllerProps<TFieldValues>["rules"];
};

export default function ReadOnlyDateInput<TFieldValues extends FieldValues>({
  control,
  name,
  rules,
  ...attributes
}: ReadOnlyDateInputProps<TFieldValues>) {
  const { field } = useController({ control, name, rules });

  return (
    <TextInput
      {...attributes}
      ref={field.ref}
      readOnly
      value={field.value ? formatDateOnly(field.value) : ""}
    />
  );
}
